import { getFlavorAllAction } from './getFlavorAllAction';
import { getFlavorTypeAction } from './getFlavorTypeAction';

export const flavorsActions = {
  getAll: getFlavorAllAction,
  getType: getFlavorTypeAction,
};
